"use strict";

/* eslint-disable no-undef, func-names */
jQuery(document).ready($ => {
  var contentLibraryTable = '#snc-content_library_wrap table';
  $("".concat(contentLibraryTable, " a.content_title, ").concat(contentLibraryTable, " a.show")).click(function (e) {
    e.preventDefault();
    var id = $(this).attr('data-item_id');
    $('.embed_information').each(function () {
      var theId = $(this).attr('data-item_id');
      if (id !== theId) {
        $(this).hide();
      } else {
        $(this).toggle();
      }
    });
  });
});